var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveMoreGiftsZh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 217,
    viewBox: "0 0 264 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.7545 19.4574L55.0215 26.36C70.0562 22.0459 106.418 44.5224 108.319 45.7303L135.052 38.8278C133.151 37.6198 96.7469 15.1433 81.7545 19.4574Z",
    fill: "#D69B00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2827 40.1218C65.794 30.1993 69.0459 19.2415 79.0127 16.3942C50.9705 23.6419 47.1273 23.4262 43.9177 29.9405C41.0881 35.7214 43.4109 42.1926 47.5497 47.0675C57.6009 58.845 102.874 49.656 105.239 49.1814L131.972 42.2788C129.565 42.7103 84.2917 51.8993 74.2827 40.1218Z",
    fill: "url(#paint0_linear_2790_19768)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9766 16.3942C82.1018 15.4882 85.8604 15.3588 90.1259 16.3079C108.159 20.2338 135.399 37.8785 136.835 38.8276H135.061C133.161 37.6628 96.7564 15.1431 81.7639 19.4572C81.0037 19.6729 80.2858 19.9749 79.6523 20.3632C66.1802 28.3012 75.7669 42.2357 94.9404 43.832C114.114 45.385 131.091 42.4083 132.02 42.2789C129.655 42.7534 84.3823 51.9425 74.331 40.165C65.8001 30.1994 69.0098 19.2847 78.9766 16.3942Z",
    fill: "#FFC01A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M172.944 13.5461C172.691 13.5892 172.48 13.6755 172.226 13.7186C159.261 17.3856 138.694 42.1486 130.543 52.9339L161.879 61.9935C169.566 51.8122 194.778 20.9663 207.321 22.3468C208.293 22.4331 209.179 22.6488 209.982 22.8645C176.154 13.1146 176.703 12.7264 172.944 13.5461Z",
    fill: "#D69B00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M212.394 18.853L181.058 9.79333C190.898 12.6406 190.645 27.6106 182.114 35.2035C171.725 44.3925 147.737 51.7265 134.434 54.8327L165.77 63.8923C178.862 60.8293 212.057 51.2088 217.842 38.7842C221.221 31.4502 220.672 21.2257 212.394 18.853Z",
    fill: "url(#paint1_linear_2790_19768)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.434 9.49115C185.444 7.98121 191.609 16.5663 186.71 29.0772C180.925 43.8746 136.707 54.2717 134.385 54.7893C135.272 54.5736 151.742 50.2595 168.846 40.8979C185.993 31.5794 190.68 14.9701 175.983 13.3307C175.266 13.2444 174.548 13.2876 173.787 13.3739C158.753 15.6603 131.935 51.0792 130.542 52.9343L128.895 53.6677C129.95 52.244 149.757 24.9788 165.172 13.9778C168.846 11.3894 172.352 9.9657 175.434 9.49115Z",
    fill: "#FDB400"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M135.687 217L62.0764 210.055L46.7461 60.6569L137.588 47.3263L135.687 217Z",
    fill: "#BF253E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M221.889 59.0175L201.28 209.666L135.693 217L137.594 47.3263L221.889 59.0175Z",
    fill: "#E83350"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.196 46.1611C84.3347 26.1867 94.7238 7.85176 98.3558 5.479C102.368 2.89053 143.037 -4.05519 156.89 3.23566C170.742 10.5697 152.117 43.702 152.117 43.702L108.196 46.1611Z",
    fill: "url(#paint2_linear_2790_19768)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M204.669 52.5462L183.173 211.478L164.422 213.721L177.767 47.9301L204.669 52.5462Z",
    fill: "url(#paint3_linear_2790_19768)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3145 52.4165L92.2737 47.8435L102.283 213.851L85.7699 212.47L67.3145 52.4165Z",
    fill: "url(#paint4_linear_2790_19768)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 108.5,
    width: 263.715,
    height: 72.3333,
    rx: 36.1667,
    fill: "#FFD03B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4828 127.155H79.6236V131.544H43.4828V127.155ZM59.2764 129.042H64.4453V145.615C64.4453 153.902 61.0404 160.793 45.575 163.87C45.0417 162.762 43.6469 160.629 42.5803 159.522C57.3894 157.265 59.2764 152.097 59.2764 145.533V129.042ZM51.6873 144.261V146.969H72.1165V144.261H51.6873ZM51.6873 137.944V140.569H72.1165V137.944H51.6873ZM47.0518 133.965H77.0391V150.907H47.0518V133.965ZM51.9334 150.743C57.6766 158.086 67.2758 158.66 81.2645 158.537C80.403 159.686 79.4595 161.778 79.2133 163.419C64.7324 163.132 53.9025 161.778 47.6261 152.466L51.9334 150.743ZM97.7496 135.483L101.072 132.734C103.534 133.924 106.816 135.811 108.415 137.246L104.929 140.282C103.452 138.846 100.252 136.795 97.7496 135.483ZM116.251 128.386H117.194L117.974 128.181L121.173 130.027C115.84 139.913 104.231 145.246 92.2936 147.666C91.8834 146.435 90.8988 144.507 90.0374 143.441C101.113 141.677 112.189 136.754 116.251 129.083V128.386ZM103.288 128.386H117.358V132.406H103.288V128.386ZM105.544 125.186L110.918 126.335C106.733 131.093 101.319 134.949 93.6473 137.985C92.95 136.836 91.4321 135.154 90.3656 134.375C97.6675 131.996 102.754 128.55 105.544 125.186ZM103.329 151.03L106.898 148.281C109.4 149.635 112.682 151.727 114.323 153.327L110.508 156.363C109.072 154.804 105.872 152.507 103.329 151.03ZM121.42 143.359H122.404L123.266 143.154L126.547 144.836C121.543 157.06 109.687 161.901 95.5754 163.87C95.2062 162.516 94.3037 160.506 93.4833 159.399C106.487 158.045 117.604 153.737 121.42 144.056V143.359ZM109.359 143.359H122.732V147.461H109.359V143.359ZM112.23 139.38L117.604 140.61C113.01 145.984 106.692 150.333 97.6265 153.614C97.0522 152.466 95.6574 150.661 94.6319 149.799C103.206 147.215 109.072 143.277 112.23 139.38ZM155.503 155.501L159.277 154.517C160.18 155.912 160.918 157.84 161.164 159.111L157.185 160.301C157.021 158.988 156.283 156.937 155.503 155.501ZM166.333 154.394L170.599 155.542C169.697 157.347 168.795 159.029 168.138 160.219L164.487 159.152C165.144 157.799 165.923 155.789 166.333 154.394ZM157.718 149.84V151.932H167.933V149.84H157.718ZM153.657 146.969H172.158V154.804H153.657V146.969ZM156.283 135.647V137.493H169.205V135.647H156.283ZM156.283 130.97V132.816H169.205V130.97H156.283ZM152.345 127.934H173.348V140.528H152.345V127.934ZM151.77 141.882H174.004V145.574H151.77V141.882ZM150.95 159.44H174.579V163.05H150.95V159.44ZM157.842 125.309H161.493V130.191H157.842V125.309ZM163.913 125.309H167.564V130.191H163.913V125.309ZM158.58 129.329H161.451V139.913H158.58V129.329ZM163.913 129.329H166.784V139.913H163.913V129.329ZM136.469 136.057H150.868V140.323H136.469V136.057ZM137.453 127.893H150.047V132.119H137.453V127.893ZM147.586 142.374H150.704V157.676H147.586V142.374ZM141.843 138.19H145.904V163.829H141.843V138.19ZM137.043 142.456H140.161V147.379C140.161 151.604 139.956 156.486 138.479 160.424C137.864 159.768 136.592 158.783 135.73 158.332C136.838 155.009 137.043 150.825 137.043 147.256V142.456ZM202.837 125.309L207.268 126.17C205.791 132.98 203.083 139.503 199.761 143.605C198.981 142.867 197.053 141.472 196.028 140.856C199.309 137.246 201.607 131.38 202.837 125.309ZM216.621 131.708H221.256C221.256 131.708 221.215 133.308 221.174 133.924C220.395 152.343 219.656 159.07 218.098 161.122C217.154 162.516 216.252 163.009 214.898 163.255C213.749 163.501 212.026 163.501 210.221 163.419C210.098 162.024 209.606 159.932 208.868 158.578C210.385 158.742 211.78 158.783 212.56 158.783C213.175 158.783 213.544 158.578 214.036 158.004C215.185 156.568 215.964 150.21 216.621 132.775V131.708ZM204.068 131.708H218.713V136.262H201.812L204.068 131.708ZM206.939 133.185L210.508 134.949C208.868 142.005 205.258 150.127 200.786 154.312C199.843 153.368 198.284 152.22 197.012 151.522C201.771 147.789 205.381 140.077 206.939 133.185ZM212.642 133.636L216.457 135.4C214.488 146.066 210.139 157.224 203.371 162.885C202.427 161.901 200.704 160.67 199.35 160.014C206.529 154.886 210.755 144.179 212.642 133.636ZM182.736 147.666C186.756 146.764 192.746 145.082 198.407 143.482L199.063 147.83C193.894 149.43 188.274 151.112 183.926 152.384L182.736 147.666ZM190.12 125.309H194.633V163.829H190.12V125.309ZM184.705 127.647L188.808 128.345C188.274 133.76 187.29 139.503 185.813 143.154C185.075 142.579 183.311 141.431 182.326 140.938C183.639 137.657 184.336 132.529 184.705 127.647ZM185.813 133.226H198.038V137.944H184.91L185.813 133.226Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2790_19768",
    x1: 76.7994,
    y1: 2.55186,
    x2: 89.8055,
    y2: 46.7396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3089,
    stopColor: "#FFFA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C79000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2790_19768",
    x1: 193.889,
    y1: -2.04015,
    x2: 172.475,
    y2: 54.4594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    stopColor: "#FFFA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8859,
    stopColor: "#C79000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2790_19768",
    x1: 125.171,
    y1: -6.27256,
    x2: 130.703,
    y2: 46.1463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    stopColor: "#FFFA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.845,
    stopColor: "#C79000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2790_19768",
    x1: 244.541,
    y1: -15.0272,
    x2: 117.245,
    y2: 260.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2777,
    stopColor: "#FFFA85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8859,
    stopColor: "#C79000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2790_19768",
    x1: 98.7685,
    y1: 26.3884,
    x2: 68.3851,
    y2: 248.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0622507,
    stopColor: "#F5BB19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144,
    stopColor: "#ECC333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2175,
    stopColor: "#E7C742"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2753,
    stopColor: "#E5C948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8388,
    stopColor: "#C79000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveMoreGiftsZh);
export default __webpack_public_path__ + "static/media/live-more-gifts-zh.9af933903cd6191e331afc75b1900586.svg";
export { ForwardRef as ReactComponent };